import script from "./UserDetails.vue?vue&type=script&lang=ts&setup=true"
export * from "./UserDetails.vue?vue&type=script&lang=ts&setup=true"

import "./UserDetails.vue?vue&type=style&index=0&id=4fc5971e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4fc5971e"]])

export default __exports__